import { formatPrice } from 'features/home/components/HomeSubscription/utils'
import IntlFormattedDate from 'app/i18n/IntlFormattedDate'
import {
  PurchaseSubscritpionTotalBlock,
  PurchaseSubscritpionBlockItem,
  PurchaseSubscritpionNetworkTotalLabel,
  PurchaseSubscritpionItemTitle,
  PurchaseSubscritpionItemSubTitle,
  PurchaseSubscritpionTotalTitle,
  PurchaseSubscritpionItemCount,
  PurchaseSubscritpionItemSum,
  BottomLine,
  BilledAnnualWrapper,
  BilledAnnualLabel,
  TaxTotalCostTitle,
  PurchaseSubscritpionPointsSum,
} from '../styles'

import { useIntl } from 'react-intl'
import { subscriptionManagementMessages } from 'features/home/components/HomeSubscription/SubscriptionManagement/messages'

export interface PurchaseDeviceTotalProps {
  apQuantity: number
  apPrice: number
  essentialsPrice: number
  totalPrice: number
  renewalDate: number
  subscriptionState: string
  essentialsCredits: number
  apCredits: number
}

const PurchaseDeviceTotal = (props: PurchaseDeviceTotalProps) => {
  const {
    apQuantity,
    apPrice,
    essentialsPrice,
    totalPrice,
    renewalDate,
    subscriptionState,
    essentialsCredits,
    apCredits,
  } = props
  const { formatMessage } = useIntl()

  return (
    <PurchaseSubscritpionTotalBlock>
      <PurchaseSubscritpionBlockItem>
        <PurchaseSubscritpionNetworkTotalLabel>
          Home Subscription Details
        </PurchaseSubscritpionNetworkTotalLabel>
      </PurchaseSubscritpionBlockItem>

      {subscriptionState === 'ENROLLED' && essentialsPrice !== undefined && (
        <PurchaseSubscritpionBlockItem>
          <PurchaseSubscritpionItemTitle>
            Savant Essentials
          </PurchaseSubscritpionItemTitle>
          <PurchaseSubscritpionPointsSum>
            {formatPrice(essentialsPrice || 0)}
          </PurchaseSubscritpionPointsSum>
        </PurchaseSubscritpionBlockItem>
      )}

      <PurchaseSubscritpionBlockItem>
        <div>
          <PurchaseSubscritpionItemTitle>
            Access Points
          </PurchaseSubscritpionItemTitle>
          <PurchaseSubscritpionItemCount>
            x {apQuantity}
          </PurchaseSubscritpionItemCount>
        </div>
        <PurchaseSubscritpionPointsSum>
          {formatPrice(apPrice * apQuantity)}
        </PurchaseSubscritpionPointsSum>
      </PurchaseSubscritpionBlockItem>
      <BottomLine />
      <PurchaseSubscritpionBlockItem>
        <PurchaseSubscritpionTotalTitle>
          Total Price
        </PurchaseSubscritpionTotalTitle>
        <PurchaseSubscritpionItemSum>
          {formatPrice(totalPrice)}
        </PurchaseSubscritpionItemSum>
      </PurchaseSubscritpionBlockItem>
      <BilledAnnualWrapper>
        <BilledAnnualLabel>Billed Annually</BilledAnnualLabel>
      </BilledAnnualWrapper>

      {essentialsCredits > 0 && (
        <>
          <BottomLine />
          <PurchaseSubscritpionBlockItem>
            <PurchaseSubscritpionItemSubTitle>
              Savant Essentials Credit
            </PurchaseSubscritpionItemSubTitle>
            <PurchaseSubscritpionPointsSum>
              {formatPrice(essentialsCredits)}
            </PurchaseSubscritpionPointsSum>
          </PurchaseSubscritpionBlockItem>
        </>
      )}

      {apCredits > 0 && (
        <PurchaseSubscritpionBlockItem>
          <PurchaseSubscritpionItemSubTitle>
            Access Points Credit
          </PurchaseSubscritpionItemSubTitle>
          <PurchaseSubscritpionPointsSum>
            {formatPrice(apCredits)}
          </PurchaseSubscritpionPointsSum>
        </PurchaseSubscritpionBlockItem>
      )}

      <BottomLine />
      <PurchaseSubscritpionBlockItem>
        <PurchaseSubscritpionItemSubTitle>
          Renewal Date
        </PurchaseSubscritpionItemSubTitle>
        <PurchaseSubscritpionItemTitle>
          <IntlFormattedDate date={renewalDate} />
        </PurchaseSubscritpionItemTitle>
      </PurchaseSubscritpionBlockItem>
      <BottomLine />

      <PurchaseSubscritpionBlockItem>
        <TaxTotalCostTitle>
          {formatMessage(subscriptionManagementMessages.upgradePlanBottomText)}
        </TaxTotalCostTitle>
      </PurchaseSubscritpionBlockItem>
    </PurchaseSubscritpionTotalBlock>
  )
}

export default PurchaseDeviceTotal
